import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, fromProjectResource, toProjectResource, tasks }) =>
    present(
      repository
        .transferProjectResourceAllocations(
          project,
          fromProjectResource,
          toProjectResource,
          tasks,
        )
        .then(() => ({
          project,
          fromProjectResource,
          toProjectResource,
          tasks,
        }))
        .catch(() =>
          Promise.reject({
            project,
            fromProjectResource,
            toProjectResource,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
